module.exports = __webpack_public_path__ + "static/media/527GriffinStNW_2018-06-05_14.cb7a4f89.jpg";